import { createContext } from 'react';
import noop from 'lodash/noop';

import api from '../api';
import { ServiceType } from '../types';
import { ByIdStructure, Context } from '../../../types';

const ServiceTypesContext = createContext<Context<ServiceType>>({
    get: api.get,
    getById: api.getById,
    getSchema: api.getSchema,
    schema: {},
    post: api.post,
    put: api.put,
    data: { ids: [], byId: {} } as ByIdStructure<ServiceType>,
    setData: noop,
    selected: null,
    setSelected: noop,
    remove: api.remove,
    error: null
});
export default ServiceTypesContext;
